import { Chip } from "@mui/material";

type ChipProps = {
  selected: boolean,
  label: string;
  emptyLabel: string;
  onClick: () => void;
  onDelete: () => void;
};

export const FilterChip = ({ selected, label, emptyLabel, onClick, onDelete }: ChipProps) => <Chip
  label={selected ? label : emptyLabel}
  onDelete={selected ? onDelete : undefined}
  onClick={onClick}
  color={selected ? "primary" : "default"}
  variant={selected ? "filled" : "outlined"}
/>;